// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const initialColumnSize = "224px";
export const noComparison = "CategoriesModule__noComparison__u5nLT";
export const categoriesModule = "CategoriesModule__categoriesModule__ua6J7";
export const carousel = "CategoriesModule__carousel__VoqON";
export const row = "CategoriesModule__row__AjJwp";
export const pieSection = "CategoriesModule__pieSection__Sm5gQ";
export const groupNames = "CategoriesModule__groupNames__D-dec";
export const groupName = "CategoriesModule__groupName__wE9cq font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const active = "CategoriesModule__active__DwC9D";
export const dots = "CategoriesModule__dots__C40Xo";
export const dot = "CategoriesModule__dot__ZmQuh";
export const activeDot = "CategoriesModule__activeDot__XW9-f";
export const pieTitle = "CategoriesModule__pieTitle__FED3T";
export const member = "CategoriesModule__member__Q7j-y";
export const peers = "CategoriesModule__peers__9+L5W";
export const others = "CategoriesModule__others__aCb+i";
export const pieTitleName = "CategoriesModule__pieTitleName__K3TiX font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const pieTitleValue = "CategoriesModule__pieTitleValue__qR-j+ font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const pieWrapper = "CategoriesModule__pieWrapper__3rrAn";
export const lists = "CategoriesModule__lists__+y7lM";
export const listWrapper = "CategoriesModule__listWrapper__csyYw";
export const buttonWrapper = "CategoriesModule__buttonWrapper__FNoXb";